import React from "react";
import LoginForm from "../../components/molecules/loginForm/LoginForm";
import "./LoginTemplate.css";
import { assets } from "../../publics/assets";

const Contours = () => (
  <svg
    className="login-brand__contours"
    viewBox="0 0 600 800"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    <g fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M-20 620 C 80 540, 160 600, 260 540 S 440 470, 640 520" />
      <path d="M-20 590 C 90 500, 170 570, 270 505 S 450 430, 640 485" />
      <path d="M-20 560 C 100 465, 180 540, 280 470 S 460 392, 640 450" />
      <path d="M-20 530 C 110 430, 190 510, 290 435 S 470 355, 640 415" />
      <path d="M-20 500 C 120 395, 200 480, 300 400 S 480 318, 640 380" />
      <path d="M-20 470 C 130 360, 210 450, 310 365 S 490 281, 640 345" />
      <path d="M-20 440 C 140 325, 220 420, 320 330 S 500 244, 640 310" />
      <path d="M-20 410 C 150 290, 230 390, 330 295 S 510 207, 640 275" />
      <path d="M120 120 C 200 60, 340 70, 400 140 S 430 280, 330 320 S 120 300, 90 220 S 80 160, 120 120Z" />
      <path d="M160 150 C 220 105, 320 112, 365 165 S 385 262, 315 290 S 170 275, 148 218 S 135 178, 160 150Z" />
      <path d="M205 185 C 245 160, 305 165, 330 198 S 338 245, 296 262 S 215 252, 200 222 S 190 200, 205 185Z" />
    </g>
  </svg>
);

const LoginTemplate = ({ onSubmit, loading, error }) => (
  <main className="login-view">
    <section className="login-brand">
      <Contours />

      <div className="login-brand__top">
        {assets.edhec_climateInnov_white && (
          <img
            src={assets.edhec_climateInnov_white}
            alt="EDHEC · Climate Innov"
            className="login-brand__logo"
          />
        )}
      </div>

      <div className="login-brand__body">
        <h1 className="login-brand__title">
          Mesurez ce que chaque intervention a permis de sauver.
        </h1>
        <p className="login-brand__text">
          Comparez l’incendie réel et le scénario sans intervention, puis
          chiffrez les surfaces, les bâtiments et le carbone préservés.
        </p>
      </div>
    </section>

    <section className="login-main">
      <div className="login-card">
        <header className="login-card__header">
          <h2 className="login-card__title">Connexion</h2>
          <p className="login-card__subtitle">
            Accédez à votre espace d’analyse.
          </p>
        </header>

        <LoginForm onSubmit={onSubmit} loading={loading} error={error} />
      </div>
    </section>
  </main>
);

export default LoginTemplate;